import React from "react";
import { Tooltip } from "@mui/material";
import { useUi } from "../context/UiContext";
import { useTranslateText } from "../context/LanguageContext";

export default function MaybeTooltip({ title, children, ...rest }) {
  const { showTooltips } = useUi();
  const translateText = useTranslateText();

  if (!showTooltips || !title) return children;

  return (
    <Tooltip title={typeof title === "string" ? translateText(title) : title} {...rest}>
      {children}
    </Tooltip>
  );
}
